module.exports = __webpack_public_path__ + "static/media/ic-menu.c91ea1d9.svg";